export class ListAccountsResponse {
    'accounts';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accounts",
            "baseName": "accounts",
            "type": "Array<Account>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAccountsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
